import isSaleAllowed from '../utils/material/is-sale-allowed';
import { isFreeMaterial } from '../utils/material/material-helper';

const useSale = (material: Material, countryCode: string) => {
    const saleAllowed = isSaleAllowed(material, countryCode);

    const materialIsFree = isFreeMaterial(material);
    const isSale = !materialIsFree && material.sale && saleAllowed;
    const isFreeSale = materialIsFree && material.sale && saleAllowed;

    return { isSale, isFreeSale };
};

export default useSale;
